import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

const SendNotesDialog = ({ open, notes, onNotesChange, onCancel, onSubmit }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>Stage selection with notes</DialogTitle>
    <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="Notes (for your reference only)"
        value={notes}
        onChange={(event) => onNotesChange(event.target.value)}
        multiline
        minRows={4}
        fullWidth
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button variant="contained" onClick={onSubmit} disabled={!notes?.trim()}>
        Stage with notes
      </Button>
    </DialogActions>
  </Dialog>
);

export default SendNotesDialog;
